import script from "./TimeNumbers.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeNumbers.vue?vue&type=script&setup=true&lang=js"

import "./TimeNumbers.vue?vue&type=style&index=0&id=58c5163a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c5163a"]])

export default __exports__